import { ColumnRank, ColumnBib, ColumnName, ColumnNoc, ColumnStartOrder, ColumnResult, ColumnPoints, 
    ColumnDifference, ColumnQualification, CellRank, CellDiff } from "components/common/TableColumns"
import Label from "components/general/Label"
import SportCode from 'components/common/SportCode'
import { findArray } from 'helpers/utils'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera } from "@fortawesome/free-solid-svg-icons";

export function ColumnRankBmx({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap align-middle',
    label = 'HeaderRank',
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rank',
            Cell: (props) => {
                let row = props.cell.row.original
                let photo = findArray(row.extendedResults, { er_code: ['PHOTO'] })?.er_value
                console.log(row)
                return (
                    photo === 'P' 
                    ? <><FontAwesomeIcon icon={faCamera}/></>
                    : <CellRank node={row}></CellRank>
                )
            },
        }
    )
}

export function ColumnAfterResult({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10 ',
    label = '',
    remove = false,
    runNumber = ''
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => { return props.sortOrder },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result2',
            remove: remove,

            Cell: (props) => {
                let summary = props?.cell?.row?.original?.summaryResults
                let irmBefore = summary?.extendedResults?.find(er => er?.er_pos === runNumber)?.er_irm
                let valueBefore = summary?.extendedResults?.find(er => er?.er_pos === runNumber)?.er_value
                let pointsBefore = summary?.extendedResults?.find(er => er?.er_pos === runNumber)?.er_value2

                return (
                    irmBefore
                    ? <SportCode discipline='BMX' entity='@IRM' code={irmBefore} abbr={true} />
                    : summary?.resultType === 'POINTS' && valueBefore && pointsBefore  
                        ? `${valueBefore} (${pointsBefore})` 
                        : ''
                )
            },
        }
    )
}

export function ColumnResultBmx({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10 ',
    label = 'HeaderResult',
    remove = false,
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => { return props.sortOrder },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',
            remove: remove,
            Cell: (props) => {
                let row = props.cell.row.original   
                let photo = findArray(row.extendedResults, { er_code: ['PHOTO'] })?.er_value
                return (
                    row?.resultType === 'IRM'
                    ? <SportCode discipline='BMX' entity='@IRM' code={row?.irm} abbr={true} />
                    : photo === 'P'
                        ? ''
                        : row?.resultType === 'TIME'   
                            ? row?.resultData 
                            : ''
                )
            },
        }
    )
}

export function ColumnPointsBmx({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderPoints'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'SortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Points',
            Cell: (props) => {
                let row = props.cell.row.original
                let extendedResult = findArray(row?.extendedResults, { er_code: ['PTS'] });
                let photo = findArray(row.extendedResults, { er_code: ['PHOTO'] })?.er_value
                return (
                    photo === 'P' 
                    ? ''
                    : extendedResult
                )
            }
        }
    )
}

export function ColumnDifferenceBmx({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTimeBehind'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'diff',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Diff',
            Cell: (props) => {
                let row = props.cell.row.original
                let photo = findArray(row.extendedResults, { er_code: ['PHOTO'] })?.er_value
                return (
                    photo === 'P' 
                    ? ''
                    : <CellDiff node={row} ></CellDiff>
                )
            },
        }
    )
}

export function TableColumnsStartList() {
    return (
        [
            ColumnBib({ label:"HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelectionOrder"}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnPoints({})
        ]
    )
}

export function TableColumnsLive() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({ label:"HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelected"}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnPoints({})
        ]
    )
}

export function TableColumnsLive2() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({ label:"HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelected"}),
            ColumnAfterResult({ label: "HeaderAfterRun1", runNumber:"RUN1"}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnPoints({ label: "HeaderRun2Points" })
        ]
    )
}

export function TableColumnsLive3() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({ label:"HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelected"}),
            ColumnAfterResult({ label: "HeaderAfterRun2", runNumber:"RUN2" }),
            ColumnResult({ label: "HeaderTime" }),
            ColumnPoints({ label: "HeaderRun3Points" })
        ]
    )
}

export function TableColumnsLiveRepFnl() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({ label:"HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelected"}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnDifference({ label: "HeaderGap" })
        ]
    )
}

export function TableColumnsFinish() {
    return (
        [
            ColumnRankBmx({ hasIrm: false }),
            ColumnBib({ label:"HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelected"}),
            ColumnResultBmx({ label: "HeaderTime" }),
            ColumnPointsBmx({})
        ]
    )
}

export function TableColumnsFinishRepFnl() {
    return (
        [
            ColumnRankBmx({ hasIrm: false }),
            ColumnBib({ label:"HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelected"}),
            ColumnResultBmx({ label: "HeaderTime" }),
            ColumnDifferenceBmx({ label: "HeaderGap" }),
            ColumnQualification({ className:"text-end fw-bold" }),
        ]
    )
}

export function TableColumnsStartListSM() {
    return (
        [
            ColumnBib({ label:"HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelectionOrder"}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnPoints({ label: "HeaderPoints" })
        ]
    )
}

export function TableColumnsStartListRepFnlSM() {
    return (
        [
            ColumnBib({ label:"HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelectionOrder"}),
            ColumnResult({ label: "HeaderTime" }),
        ]
    )
}

export function TableColumnsLiveSM() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({ label:"HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelected"}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnPoints({ label: "HeaderPoints" })
        ]
    )
}

export function TableColumnsLiveRepFnlSM() {
    return (
        [
            ColumnRank({ hasIrm: false }),
            ColumnBib({ label:"HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelected"}),
            ColumnResult({ label: "HeaderTime" }),
            ColumnDifference({ label: "HeaderGap" })
        ]
    )
}

export function TableColumnsFinishSM() {
    return (
        [
            ColumnRankBmx({ hasIrm: false }),
            ColumnBib({ label:"HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnStartOrder({ label:"HeaderGateSelected"}),
            ColumnResultBmx({ label: "HeaderTime" }),
            ColumnPointsBmx({ label: "HeaderPoints" })
        ]
    )
}

export function TableColumnsFinishRepFnlSM() {
    return (
        [
            ColumnRankBmx({ hasIrm: false }),
            ColumnBib({ label:"HeaderNumber" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResultBmx({ label: "HeaderTime" }),
            ColumnDifferenceBmx({ label: "HeaderGap" }),
            ColumnQualification({ className:"text-end fw-bold" }),
        ]
    )
}